import React, { useCallback, useEffect, useState } from "react"; 
import { useNavigate } from "react-router-dom";   
import { Helmet } from "react-helmet";
import config from "src/config";
import { useDispatch } from "react-redux";
import { useNotification } from "src/components/Notifination/ToastNotification";
import { LoginDefaultProps, LoginYupSchema } from "./LoginPropTypes";
import { Formik, Form } from 'formik';
import FormikInput from 'src/components/formik/FormikInput';
import { includeStamp } from 'src/utils/StampUtils';
import { handleLogin } from "src/api/AuthAPI";
import { fetchUserScopesAction, loginSuccess } from "../home-container/actions/authAction";
import { setDefaultHeaders } from "src/utils/RequestUtil";


const Render =(props)=>{
     return (
        <>
        <Form autoComplete="disabled">
                <div className="icon-field mb-16">
                    <span className="icon top-50 translate-middle-y">
                        <iconify-icon icon="mage:email"></iconify-icon>
                    </span>
                    {/* <input type="email" className="form-control h-56-px bg-neutral-50 radius-12" placeholder="Email"/> */}
                        <FormikInput
                        name="username"
                        placeholder="Employee ID"
                        className="form-control h-56-px bg-neutral-50 radius-12"
                        /> 
                </div>
                <div className="position-relative mb-20">
                    <div className="icon-field">
                        <span className="icon top-50 translate-middle-y">
                            <iconify-icon icon="solar:lock-password-outline"></iconify-icon>
                        </span> 
                        {/* <input type="password" className="form-control h-56-px bg-neutral-50 radius-12" id="your-password" placeholder="Password"/> */}
                        <FormikInput
                          id="your-password"
                          name="password"
                          placeholder="Password"
                          className="form-control h-56-px bg-neutral-50 radius-12"
                        />
                    </div>
                    <span className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light" data-toggle="#your-password"></span>
                </div>
                <div className="">
                    <div className="d-flex justify-content-between gap-2">
                        <div className="form-check style-check d-flex align-items-center">
                            {/* <input className="form-check-input border border-neutral-300" type="checkbox" value="" id="remeber"/> */}
                                <FormikInput
                                id="remeber"
                                type="checkbox" 
                                name="departmentName"
                                placeholder="Enter the department name here."
                                className="form-check-input border border-neutral-300"
                                /> 
                            <label className="form-check-label" for="remember">Remember me </label>
                        </div>
                        {/* <a href="#" onClick={(e) => e.preventDefault()} className="text-primary-600 fw-medium">Forgot Password?</a> */}
                    </div>
                </div> 
                <button type="submit" className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"> Sign In</button>  
                </Form>
        </>
     )
}
let setSubmitting = () => { };
const Login = () => { 
  const { openSuccessNotification, openErrorNotification } = useNotification();
  const navigate = useNavigate();  
  const dispatch = useDispatch();
  const token  = localStorage.getItem("token");
  if(token) navigate('/');
  
  const onSubmit = useCallback(async(
    values,
    formikUtils,
) => {
    ({ setSubmitting } = formikUtils);     
    // includeStamp(values); 
    // console.log('values=>',values);
    // dispatch(departmentUpsertAction(values));
    const { data } = await handleLogin(values);
    const { token, user } = data;
    if (token) {
      localStorage.setItem("user", JSON.stringify({ ...user }));
      localStorage.setItem("token", JSON.stringify(token)); 
      localStorage.setItem("userData", JSON.stringify(values)); 
      dispatch(loginSuccess({ ...user, jwtToken: token }));
      setDefaultHeaders({
        Authorization: token,
       });
      dispatch(fetchUserScopesAction({ userId:user._id,roleId:user?.roleDetails?._id }));
      navigate("/", { replace: true });
      openSuccessNotification("Welcome! Logged In Successfully.");
    }
    else{
      navigate("/login");
      openErrorNotification("Login failed. Please check your credentials and try again.");
    }
}, [
    dispatch,
]);

  return (
    <>
    <Helmet>
    <section>
      <title>index - </title>
      <link href="assets/css/style-custom.css" rel="stylesheet" />
      <link href="assets/css/assets/css/style.css" rel="stylesheet" />
      <link href="assets/css/dragndrop.table.columns.css" rel="stylesheet" />
    </section>
  </Helmet> 
      <section className="auth bg-base d-flex flex-wrap">  
    <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="/assets/images/auth-img.png" alt=""/>
        </div>
    </div>
    <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
            <div>
                <a href="/" className="mb-40 max-w-290-px">
                   <img src="/assets/images/left-sidebar/logo.svg" alt="site logo" className="light-logo"/>
                </a>
                <h4 className="mb-12">Sign In to your Account</h4>
                <p className="mb-32 text-secondary-light text-lg">Welcome back! please enter your detail</p>
            </div>
            <Formik
            onSubmit={onSubmit} 
            enableReinitialize
            initialValues={LoginDefaultProps}
            validationSchema={LoginYupSchema}
            >
            {(formikProps) => (
                <Render 
                    {...formikProps}
                />
            )}
   </Formik>


        </div>
    </div>
</section>
      </>
 
  );
};


export default Login;
